import { StyledCell } from '../Row.style';
import { StyledLink } from '../../../ResourceAllocationOverview.style';
import { Tooltip } from '@material-ui/core';
import Icon from 'components/base/Icon';
import Text from 'components/base/Text';
import { Flex } from 'components/base/layout-components';
import { useSelector } from 'react-redux';
import { pmToolDefinitionSelector } from 'state/selectors/sensors-authorizations';

const ViewInProviderTooltip = () => {
  const pmToolDefinition = useSelector(pmToolDefinitionSelector);
  const providerName = pmToolDefinition?.name || 'Provider';

  return (
    <Flex padding='x-small'>
      <Text mr='0.8rem'>View in {providerName}</Text>
      <Icon name='LinkArrow' size='x-small' />
    </Flex>
  );
};

const KeyCell = ({ title, url }) => {
  return (
    <StyledCell>
      {url ? (
        <Tooltip title={<ViewInProviderTooltip />} placement='top-start'>
          <StyledLink target='_blank' href={url}>
            {title}
          </StyledLink>
        </Tooltip>
      ) : (
        <span>{title}</span>
      )}
    </StyledCell>
  );
};

export default KeyCell;
